// components/PrivateRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { loginUrlFor } from "../utils/authRedirect";
import { getUsableToken } from "../utils/authToken";

export default function PrivateRoute({ children }) {
  const location = useLocation();
  // An EXPIRED token is treated as no token. Checking only for presence let a stale one through,
  // so the page rendered and then authFetch's 401 handler yanked it away — a visible flash on
  // every emailed link opened more than 8 hours later.
  if (!getUsableToken()) {
    // Carry the attempted path to login so an emailed /predict/<id> link survives signing in.
    return <Navigate to={loginUrlFor(location)} replace />;
  }
  return children;
}
